/* eslint react/no-danger : 0 */
import React from 'react'
import PropTypes from 'prop-types'
import { textAligner } from '../../helpers/stylesAligner'

const TEXT_REGEX = /\\u00A0/g
const SPLIT_REGEX = /({.+?})/g

function HeadlineBlockCard({
  text,
  isGridHeadline,
  theme,
  alignText,
  gridLeadershipDesign,
  blockcardLeadershipDesign
}) {
  let firstLineClass = isGridHeadline ? 'headline-grid-one' : 'headline-one'
  let secondLineClass = isGridHeadline ? 'headline-grid-two' : 'headline-two'

  const headlineClass = isGridHeadline ? 'headline-grid-pd' : 'headline'
  const headlineContent = <h2 className={`${firstLineClass} ${textAligner(alignText)}`}>{text}</h2>

  if (text.includes('{mbr}') || text.includes('{dbr}')) {
    if (!isGridHeadline) {
      if (gridLeadershipDesign || blockcardLeadershipDesign) {
        firstLineClass = 'headline-one-leadership'
        secondLineClass = 'headline-two-leadership'
      }
    }

    if (isGridHeadline && theme === 'Dark') {
      firstLineClass = 'headline-grid-one-dark-theme'
      secondLineClass = 'headline-grid-two-dark-theme'
    }

    return (
      <h2 className={`${firstLineClass} ${textAligner(alignText)}`}>
        {text
          .replace(TEXT_REGEX, '\u00A0')
          .split(SPLIT_REGEX)
          .map((part, index) => {
            const lastIndex = text.replace(TEXT_REGEX, '\u00A0').split(SPLIT_REGEX).length
            if (part === '{mbr}') return <span key={`${part}`} className="mobile-break" />

            if (part === '{dbr}') return <span key={`${part}`} className="desktop-break" />

            if (index === lastIndex - 1 && part.indexOf('<br') > -1) {
              const lastLineParts = part.split('<br>')
              return lastLineParts.map(lastLinePart => (
                <span className={`${secondLineClass} ${textAligner(alignText)}`} key={lastLinePart}>
                  {lastLinePart}
                </span>
              ))
            }

            if (index === lastIndex - 1 && part.indexOf('<br') === -1) {
              return (
                <span key={part} className={`${secondLineClass} ${textAligner(alignText)}`}>
                  {part}
                </span>
              )
            }

            return `${part} `
          })}
      </h2>
    )
  }

  if (gridLeadershipDesign) {
    return <div className="leadership-headline-div">{headlineContent}</div>
  }

  return (
    <h2 className={`${headlineClass} ${textAligner(alignText)}`}>
      {text.replace(TEXT_REGEX, '\u00A0')}
    </h2>
  )
}

HeadlineBlockCard.defaultProps = {
  gridLeadershipDesign: false,
  blockcardLeadershipDesign: false,
  theme: 'Light',
  alignText: 'Left',
  isGridHeadline: false
}

HeadlineBlockCard.propTypes = {
  text: PropTypes.string.isRequired,
  isGridHeadline: PropTypes.bool,
  theme: PropTypes.string,
  alignText: PropTypes.string,
  gridLeadershipDesign: PropTypes.bool,
  blockcardLeadershipDesign: PropTypes.bool
}

export default HeadlineBlockCard
